import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { Button, Divider, Input } from '@crazyegginc/hatch';

import { Modal } from '/src/contexts/modal';
import { noAsteriskRegex, superLenientUrlRegex } from '/src/utils/regex';
import { matchingUrlMatches } from '../../utils';

const validationSchema = yup.object().shape({
  url: yup
    .string()
    .required('Please enter a URL.')
    .matches(superLenientUrlRegex, 'Your URL appears to be invalid.')
    .matches(noAsteriskRegex, 'Please enter your URL without a wildcard.')
    .test('matches-matching-url', 'Your URL must match the wildcard URL.', function (value) {
      const { matchingUrl } = this.parent;

      return matchingUrlMatches(matchingUrl, value);
    }),
  matchingUrl: yup.string().required('Matching URL is required.'),
});

export function ProvideEditorPageModal({ initialValue = '', matchingUrl, onConfirm = null, onDismiss }) {
  return (
    <Modal dialogClassName="!w-[640px] !p-0 !bg-[#222326]" dark onDismiss={onDismiss}>
      <div className="flex h-14 items-center bg-black px-7">
        <h2 className="text-header-4 text-white">Provide editor page</h2>
      </div>

      <div className="text-body-2 p-7 text-cadet-blue-500">
        <div className="leading-normal">
          As you’re testing multiple pages, you’ll need to select a page to make your edits to in our WYSIWYG editor.
          Any changes you apply to this page will be carried across all of the URLs you have selected for your test.
        </div>

        <Divider dashed className="-mx-7 my-5 !w-auto !border-t-cadet-blue-500/70" />
        <Formik
          validateOnMount={true}
          validateOnChange={true}
          initialValues={{ url: initialValue, matchingUrl }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            onConfirm(values.url);
          }}
        >
          {({ values, errors, handleChange, handleBlur, isSubmitting, isValid, submitCount }) => (
            <Form className="w-full">
              <Input
                theme="dark"
                size="xl"
                id="url-input"
                name="url"
                placeholder="e.g. https://www.yoursite.com/page"
                value={values.url}
                onChange={handleChange}
                onBlur={handleBlur}
                error={submitCount > 0 && (errors?.url ?? null)}
              />

              <Modal.Actions>
                <Button theme="dark" disabled={submitCount > 0 && (!isValid || isSubmitting)} type="submit">
                  Edit this page
                </Button>
              </Modal.Actions>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}
